import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

export const userSignupCompleteSchema = z
  .object({
    id: z.string(),

    firstName: z.string().trim().min(1, 'First name is required'),

    surname: z.string().trim().min(1, 'Surname is required'),

    otherNames: z.string().nullable().optional(),

    email: z.email('Valid email address is required'),

    turnstileToken: z
  .string()
  .min(1, 'Please complete the security verification.'),

    phoneNumber: z
      .string()
      .trim()
      .min(1, 'Phone number is required')
      .refine(isValidPhoneNumber, { message: 'Valid phone number is required' }),

    pwd: z.boolean(),

    ncpwdRegNo: z.string().trim().optional(),

    password: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
      .regex(/[0-9]/, 'Password must contain at least one number')
      .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character'),

    confirmPassword: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.pwd && !data.ncpwdRegNo?.trim()) {
      ctx.addIssue({
        code: 'custom',
        path: ['ncpwdRegNo'],
        message: 'NCPWD Registration Number is required',
      });
    }

    if (data.password !== data.confirmPassword) {
      ctx.addIssue({
        code: 'custom',
        path: ['confirmPassword'],
        message: 'Passwords do not match',
      });
    }
  });

export type UserSignupCompleteFormValues = z.infer<typeof userSignupCompleteSchema>;
